import { createAction } from '@reduxjs/toolkit';

import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const cardAddAddressModalSetIsModalOpen = createAction(
    'CARD_ADD_ADDRESS_MODAL::SET_IS_MODAL_OPEN',
);

const useCardAddAddressModal = () => {
    const { isModalOpen, setIsModalOpen } = useModal();

    return {
        isModalOpen,
        setIsModalOpen,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useCardAddAddressModal();

        useActionObservableCallback(
            hookAction$,
            cardAddAddressModalSetIsModalOpen().type,
            (value) => hook.setIsModalOpen(value),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [CardAddAddressModalProvider, useCardAddAddressModalContext] =
    createContextProvider(providerFactory);
